const TOKEN_COOKIE = 'stackplan_token';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export const getTokenCookie = () => {
  const match = document.cookie.match(/(?:^|; )stackplan_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : '';
};

export const setTokenCookie = (token) => {
  document.cookie = `${TOKEN_COOKIE}=${encodeURIComponent(token)}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax`;
};

export const clearTokenCookie = () => {
  document.cookie = `${TOKEN_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
};
